import AntInput from "antd/lib/input";
import clsx from "clsx";

import styles from "./Input.module.css";

type SearchProps = React.ComponentProps<typeof AntInput.Search>;

const SearchInput = ({ className, ...props }: SearchProps) => {
    return <AntInput.Search {...props} className={clsx(styles.search, className)} />;
};

export const Input = Object.assign(AntInput, {
    Search: SearchInput,
});
